import React, { useState, useRef, useCallback, useEffect } from 'react';

// Styles

import { darculaBlockWrapperStyles } from '../darculaTheme';

const {
    panelShellBase,
    titleBarStyle,
    titleBarGripStyle,
    titleBarActionsStyle,
    circleBtnResetStyle,
    circleBtnCloseStyle,
    contentScrollBase,
} = darculaBlockWrapperStyles;

const BlockWrapper = props => {
    const initialCoordinates = { x: 5, y: 5 };

    const [ position, updatePosition ] = useState(initialCoordinates);
    const [ isDragging, setIsDragging ] = useState(false);
    const dragHandleRef = useRef(null);
    const positionRef = useRef(position);

    useEffect(() => {
        positionRef.current = position;
    }, [ position ]);

    const { id, children, additionalStyles: additionalStylesProp } = props;

    const {
        overflow,
        overflowX,
        overflowY,
        ...shellAdditionalStyles
    } = additionalStylesProp ?? {};

    const contentScrollStyle = {
        ...contentScrollBase,
        ...(overflow != null && { overflow }),
        ...(overflowX != null && { overflowX }),
        ...(overflowY != null && { overflowY }),
    };

    const handleDragHandlePointerDown = useCallback(e => {
        if (e.button !== 0) {
            return;
        }

        const handle = dragHandleRef.current;
        if (!handle) {
            return;
        }

        e.preventDefault();
        handle.setPointerCapture(e.pointerId);

        const { x: panelX, y: panelY } = positionRef.current;
        const startX = e.clientX - panelX;
        const startY = e.clientY - panelY;
        setIsDragging(true);

        const onPointerMove = ev => {
            updatePosition({
                x: ev.clientX - startX,
                y: ev.clientY - startY,
            });
        };

        const endDrag = ev => {
            if (handle.hasPointerCapture(ev.pointerId)) {
                handle.releasePointerCapture(ev.pointerId);
            }
            handle.removeEventListener('pointermove', onPointerMove);
            handle.removeEventListener('pointerup', endDrag);
            handle.removeEventListener('pointercancel', endDrag);
            setIsDragging(false);
        };

        handle.addEventListener('pointermove', onPointerMove);
        handle.addEventListener('pointerup', endDrag);
        handle.addEventListener('pointercancel', endDrag);
    }, []);

    return (
        <div
            style={{
                ...panelShellBase,
                left: position.x,
                top: position.y,
                ...shellAdditionalStyles
            }}
        >
            <div style={ titleBarStyle }>
                <div style={ titleBarActionsStyle }>
                    <button
                        type="button"
                        id={ id }
                        title="Close"
                        style={ circleBtnCloseStyle }
                    >
                        &times;
                    </button>
                    <button
                        type="button"
                        title="Reset position"
                        style={ circleBtnResetStyle }
                        onClick={() => updatePosition(initialCoordinates)}
                    >
                        &#8662;
                    </button>
                </div>
                <div
                    id="draggable-bar"
                    ref={ dragHandleRef }
                    aria-label="Drag to move panel"
                    title="Drag to move"
                    style={{
                        ...titleBarGripStyle,
                        cursor: isDragging ? 'grabbing' : 'grab',
                        userSelect: 'none',
                    }}
                    onPointerDown={ handleDragHandlePointerDown }
                />
            </div>

            <div style={ contentScrollStyle }>
                { children }
            </div>
        </div>
    );
};

export default BlockWrapper;
